import {randomId} from '../../../helpers';

export default {
    data() {
        return {
            partners: {},
        };
    },
    computed: {
        partnerIds() {
            return Object.keys(this.partners);
        },
        partnerNames() {
            return _.mapValues(this.partners, (partner) => {
                return partner.type === 'natural' ?
                    `${partner.title_prefix || ''} ${partner.first_name || ''} ${partner.last_name || ''} ${partner.title_postfix || ''}`.trim() :
                    partner.first_name.trim();
            });
        },
        partnersCount() {
            return this.partnerIds.length;
        },
        canDeletePartners() {
            return this.partnersCount > 1;
        },
        partnerCountExceeded() {
            return this.partnersCount >= 20;
        },
    },
    created() {
        if (!this.partners.length) {
            this.addPartner();
        }
    },
    methods: {
        addPartner() {
            const partnerId = randomId();

            this.$set(this.partners, partnerId, {
                id: partnerId,
                type: 'natural',
                gender: 'male',
                language: defaults.shareholder_language,
                tempPreTitle: null,
                tempPostTitle: null,
                pre_title: null,
                pre_title_short: null,
                pre_title_long: null,
                post_title: null,
                post_title_short: null,
                post_title_long: null,
                auto_generate_titles: true,
                first_name: null,
                last_name: null,
                birthdate: null,
                reg_number: null,
                street: null,
                street_nr: null,
                zip_code: null,
                city: null,
                country: 'AT',
                share_percent: 0,
                representative_type: null,
                representative_subtype: null,
                representative: null,
            });
        },
        partnerRemoveConfirm(partnerId) {
            this.$refs.partnerDeleteModal.open(() => {
                this.removePartner(partnerId);
            })
        },
        removePartner(partnerId) {
            this.$delete(this.partners, partnerId);

            this.checkForPartnerDependencies(partnerId);
        },
        checkForPartnerDependencies(partnerId) {
            this.removeFromObligationList(partnerId)
        }
    }
};
